// Reusable back navigation component for legal pages
// Shows "Back to Home" for non-authenticated users and "Back to Dashboard" for authenticated users

import React from 'react'
import Link from 'next/link'
import { ArrowLeft, Home, LayoutDashboard } from 'lucide-react'
import { useAuth } from '@/lib/supabase/AuthContext'

interface BackNavigationProps {
  className?: string
  forcePublic?: boolean
}

export const BackNavigation: React.FC<BackNavigationProps> = ({
  className = '',
  forcePublic = false,
}) => {
  const { user, userProfile, getDashboardRoute } = useAuth()

  // Determine navigation destination
  const isAuthenticated = !forcePublic && !!user
  const hasProfile = !!userProfile
  
  let destination = '/'
  let buttonText = 'Back to Home'
  let icon = <Home className="w-4 h-4" />
  
  if (isAuthenticated && hasProfile) {
    destination = getDashboardRoute?.() || '/dashboard'
    buttonText = 'Back to Dashboard'
    icon = <LayoutDashboard className="w-4 h-4" />
  } else if (isAuthenticated && !hasProfile) {
    destination = '/complete-profile'
    buttonText = 'Complete Profile'
    icon = <LayoutDashboard className="w-4 h-4" />
  }

  return (
    <div className={`flex justify-start ${className}`}>
      <Link
        href={destination}
        className="inline-flex items-center gap-2 rounded-lg bg-purple-600 px-4 py-2 font-medium text-white shadow-md transition-colors duration-200 hover:bg-purple-700 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-purple-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-purple-300 dark:focus-visible:ring-offset-[#0B1020]"
      >
        <ArrowLeft className="w-4 h-4" />
        {icon}
        <span>{buttonText}</span>
      </Link>
    </div>
  )
}

export default BackNavigation
